
// Vue reactivity
import { computed } from 'vue';

// icons
import { add, trashOutline, createOutline } from 'ionicons/icons';

// components
import { IonPage, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
        IonButtons, IonButton, IonIcon, IonList, IonItem, IonLabel,
        IonItemSliding, IonItemOptions, IonItemOption, IonBackButton,
        loadingController, } from '@ionic/vue';
import LoadingSkeleton from "@/components/LoadingSkeleton.vue";

import StickerPreQuestionModal from '@/components/modals/StickerPreQuestionModal.vue';

// composables
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { utils } from '@/composables/utils';

// services
import StickerService from '@/services/StickerService';

export default {
  name: 'StickerListPage',
  components: { IonPage, IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent,
                IonButtons, IonButton, IonIcon, IonList, IonItem, IonLabel,
                IonItemSliding, IonItemOptions, IonItemOption, IonBackButton,
                LoadingSkeleton, },
  setup() {
    const { t } = useI18n();
    const store = useStore();
    const { openModal, presentPrompt, presentToast, presentAlert, formatDate, } = utils();

    // 1. declare state variables (ref to make them reactive)
    const loading = computed(() => store.state.loadingUserStickers);
    const userStickers = computed(() => store.getters.orderedUserStickers);

    const deleteSticker = async (stickerId: any) => {
      presentPrompt("", t("confirmDeleteSticker"), async () => {
        const loading = await loadingController.create({});
        await loading.present();
        StickerService.deleteUserSticker(stickerId);
        store.commit('deleteUserSticker', stickerId);
        loading.dismiss();
        presentToast( t('successDelete'), 2000 );
      });
    }
    const openStickerPreQuestionModal = async () => {
      if (userStickers.value.length >= store.state.user.maxStickerCount) {
        await presentAlert(t('reachedMaxStickerCount'));
      } else {
        await openModal(StickerPreQuestionModal, { stickerId: null });
      }
    }

    // 3. return variables & methods to be used in template HTML
    return {
      // icons
      add, trashOutline, createOutline,

      // variables
      loading, userStickers,

      // methods
      t, formatDate,
      openStickerPreQuestionModal, deleteSticker,
    }
  }
}

